<script></script>

<div class="main">
    <div class="center">
        <div class="title">
            SUSTAINABILITY
        </div>
        <div class="img-wrapper">
            <img width="100%" height="100%" src="images/web3_pages/sustainability.png" alt="sustainability">
        </div>
        <div class="detail">
            <p>Fixed Worth NFTs or FNFTs</p>
            <span>
                These are similar to old-school coins/bank-notes with a 
                proven financial and usage model with the aim to reduce 
                distrust due to traditional volatility of NFT’s worth. 
            </span>
        </div>
    </div>
</div>

<style>
    .main{
        width: 33.854vw;
        height: 47.917vw;
        box-shadow: -0.208vw 0.208vw 0.417vw rgba(0, 0, 0, 0.8);
        border-radius: 2.083vw;
        position: relative;
        background-color: #FF007F;
    }
    .center{
        width:23.229vw;
        position: absolute;
        top: 3.854vw;
        left: 0;
        right: 0;
        margin: auto;
        font-family: 'Montserrat';
        font-style: normal;
        color: #ffffff;
    }
    .title{
        font-weight: 900;
        font-size: 2.604vw;
        line-height: 74.5%;
        text-align: center;
    }
    .img-wrapper{
        margin-top: 2.396vw;
        width: 20.625vw;
        height: 27.188vw;
        padding-left: 1.302vw;
    }
    .img-wrapper img{
        pointer-events: none;
    }
    .detail{
        margin-top: 1.875vw;
        width: 24.653vw;
        height: 7.240vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .detail p{
        font-weight: 600;
        font-size: 1.563vw;
        line-height:  1.563vw;
    }
    .detail span{
        font-weight:400;
        font-size: 1.042vw;
        line-height: 1.042vw;
    }
    p{
        margin: 0;
    }
</style>